module.exports = __webpack_public_path__ + "img/star-green.559d89d0.svg";